import {
	PUT_DAYS_OFF,
	PUT_DAYS_OFF_ERROR,
	PUT_DAYS_OFF_SUCCESS,
} from '../../../constants';

export const putHolidaysReducer = (state, actions) => {
	switch (actions.type) {
		case PUT_DAYS_OFF:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case PUT_DAYS_OFF_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case PUT_DAYS_OFF_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				holidays: actions.payload,
			};
		default:
			return state;
	}
};
